import * as React from "react";
import Store from "logic/local-storage/Store";
import { useGetPacksSummary, ILLUMINATE_STORE_VERSION_KEY } from "illuminate/hooks/usePacksAPI";
import MenuItemDotBadge from "components/navigation/MenuItemDotBadge";
function IlluminateDotBadge({ text }) {
  const skippedVersion = Store.get(ILLUMINATE_STORE_VERSION_KEY);
  const {
    packsSummary: { new_packs_available, updated_packs_available, cached_version }
  } = useGetPacksSummary();
  const showBadge = (new_packs_available || updated_packs_available) && cached_version && cached_version !== skippedVersion;
  return /* @__PURE__ */ React.createElement(MenuItemDotBadge, { text, title: "New Illuminate packs available", showDot: showBadge });
}
export default IlluminateDotBadge;
